import { render, staticRenderFns } from "./DashboardLayoutNew.vue?vue&type=template&id=1380d2a4"
import script from "./DashboardLayoutNew.vue?vue&type=script&lang=js"
export * from "./DashboardLayoutNew.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayoutNew.vue?vue&type=style&index=0&id=1380d2a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports